import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import MaintennanceDropDownFilter from "../../../../components/FilterBox/MaintenanceFilter/MaintennanceDropDownFilter";
import MaintenanceFilterBox from "../../../../components/FilterBox/MaintenanceFilter/MaintenanceFilter";
import { FiMenu } from "react-icons/fi";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import MaintananceTable from "../../../../components/Tables/MaintenanceTable";
import {
  MachineWiseGrpWiseCon,
  MachineWiseGrpWiseConFun,
  StoreFilters,
} from "../../../../Redux/Slice/Maintenance/MaintenanceSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";
import MaintenanceCelender from "../../../../components/Calendar/MaintenanceCelender";
import Calendar from "react-calendar";

export const ItemWiseDailyAndMonthly = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { StoreFiltersdata, MachineWiseGrpWiseCondata } = useSelector(
    (state) => state.MaintenanceSlice,
  );


  // Selected IDs
  const [bookNameIds, setBookNameIds] = useState([]);
  const [machineGroupIds, setMachineGroupIds] = useState([]);
  const [monthIds, setMonthIds] = useState([]);

  // Search Text
  const [bookNameSearch, setBookNameSearch] = useState("");
  const [machineGroupSearch, setMachineGroupSearch] = useState("");
  const [monthSearch, setMonthSearch] = useState("");

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTORE",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "MAINTENANCESTOREDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");

  const Firm = Cookies.get("Firm");

  const financialYearMonths = [
    { name: "April", id: "04" },
    { name: "May", id: "05" },
    { name: "June", id: "06" },
    { name: "July", id: "07" },
    { name: "August", id: "08" },
    { name: "September", id: "09" },
    { name: "October", id: "10" },
    { name: "November", id: "11" },
    { name: "December", id: "12" },
    { name: "January", id: "01" },
    { name: "February", id: "02" },
    { name: "March", id: "03" },
  ];
  const selectedYearObj = DataMain?.AC_Year_List?.find(
    (y) => String(y.AcYearID) === String(FinancialYear),
  );

  const parseAcYear = (acYearStr) => {
    if (!acYearStr) return null;

    const [start, end] = acYearStr.split(" - ");

    const formatDate = (d) => {
      const [dd, mm, yyyy] = d.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(start),
      end: formatDate(end),
    };
  };

  const financialYearRange = parseAcYear(selectedYearObj?.AcYear);

  const FinYearStart = financialYearRange?.start;
  const FinYearEnd = financialYearRange?.end;

  const getMonthId = (monthValue) => {
    if (!FinYearStart || !FinYearEnd) return "";

    const startYear = new Date(FinYearStart).getFullYear();
    const endYear = new Date(FinYearEnd).getFullYear();

    // Jan–Mar → next year
    const year = Number(monthValue) <= 3 ? endYear : startYear;

    return `${year}${monthValue}`; // ex: 202404
  };

  const [showDatePicker, setShowDatePicker] = useState(false);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const isApiCalled = useRef(false);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (isApiCalled.current) return;

    isApiCalled.current = true;
    dispatch(StoreFilters());
    dispatch(
      MachineWiseGrpWiseCon({
        firm: Firm,
        Acyear: FinancialYear,
        IdxMonthNameIDs:
          filter.month && filter.month.length > 0
            ? filter.month
              .map((m) => getMonthId(String(m).padStart(2, "0")))
              .join(",")
            : getMonthId("04"),
        StartDate: safeFormat(startDate, "yyyy-MM-dd"),
        EndDate: safeFormat(endDate, "yyyy-MM-dd"),
      }),
    );
  }, [startDate, endDate]);

  const [filter, setFilter] = useState({
    bookName: [],
    machineGroup: [],
    month: [],
  });

  const [search, setSearch] = useState({
    bookName: "",
    machineGroup: "",
    month: "",
  });

  const bookNameList =
    StoreFiltersdata?.issueBooks?.map((item) => ({
      label: item.BookTypeName,
      value: item.BookTypeId,
    })) || [];

  const machineGroupList =
    StoreFiltersdata?.MachineGroup?.map((item) => ({
      label: item.MachineGroupMstName,
      value: item.MachineGroupMstID,
    })) || [];

  const monthList =
    financialYearMonths?.map((item) => ({
      label: item.name,
      value: item.id,
    })) || [];

  const columns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Qty", key: "Qty", align: "center" },
    {
      label: "DayCons. Qty",
      key: "DayconsQty",
      align: "right",
      format: "true",
    },
    {
      label: "DayCons. Val",
      key: "DayconsVal",
      align: "right",
      format: "true",
    },
    {
      label: "MonthCons. Qty",
      key: "MonthconsQty",
      align: "right",
      format: "true",
    },
    {
      label: "MonthCons. Value",
      key: "MonthconsVal",
      align: "right",
      format: "true",
    },
    { label: "Closing", key: "Closing", align: "right", format: "true" },
    { label: "Closing Amt", key: "ClosingAmt", align: "right", format: "true" },
  ];

  const initialData = (MachineWiseGrpWiseCondata?.Data || []).map((row) => ({
    ItemName: row.ItemName,
    Qty: row.Qty,
    DayconsQty: row.DayconsQty,
    DayconsVal: row.DayconsVal,
    MonthconsQty: row.MonthconsQty,
    MonthconsVal: row.MonthconsVal,
    Closing: row.Closing,
    ClosingAmt: row.ClosingAmt,
  }));

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);

  const toggleItem = (type, item) => {
    setFilter((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilter((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleSubmit = () => {
    dispatch(MachineWiseGrpWiseConFun());
    dispatch(
      MachineWiseGrpWiseCon({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        BookIDs: filter.bookName.toString(),
        MachineGroupMstIDs: filter.machineGroup.toString(),
        IdxMonthNameIDs:
          filter.month && filter.month.length > 0
            ? filter.month
              .map((m) => getMonthId(String(m).padStart(2, "0")))
              .join(",")
            : getMonthId("04"),
      }),
    );
    setShowFilter(false);
  };

  const handleSubmit1 = () => {
    dispatch(MachineWiseGrpWiseConFun());
    dispatch(
      MachineWiseGrpWiseCon({
        firm: Firm,
        Acyear: FinancialYear,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        BookIDs: bookNameIds.toString(),
        MachineGroupMstIDs: machineGroupIds.toString(),
        IdxMonthNameIDs:
          monthIds && monthIds.length > 0
            ? monthIds
              .map((m) => getMonthId(String(m).padStart(2, "0")))
              .join(",")
            : getMonthId("04"),
      }),
    );
  };

  if (!StoreFiltersdata) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!MachineWiseGrpWiseCondata || MachineWiseGrpWiseCondata === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        minHeight: "100vh",
      }}
    >

      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <Col style={{ flex: 1 }}>
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour8
                        : iscolourDark?.Colour11,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour4}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour4}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color:
                        isdark === "light"
                          ? iscolour?.Colour12
                          : iscolourDark?.Colour11,
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            </Col>
            <MaintenanceFilterBox
              title="Book Name"
              items={bookNameList}
              search={search.bookName}
              setSearch={(val) => handleSearch("bookName", val)}
              selectedItems={filter.bookName}
              toggleItem={(item) => toggleItem("bookName", item)}
              selectAll={() => selectAll("bookName", bookNameList)}
            />

            <MaintenanceFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filter.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />

            <MaintenanceFilterBox
              title="Machine Group"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(val) => handleSearch("machineGroup", val)}
              selectedItems={filter.machineGroup}
              toggleItem={(item) => toggleItem("machineGroup", item)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />

            <Button
              onClick={handleSubmit}
              style={{
                width: "100%",
                // height: "44px",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="align-items-end g-2">
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour11 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7}`,
                  color: isdark === "light" ? "#000" : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>
          {/* Book Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Book Name"
              data={bookNameList}
              selectedValue={bookNameSearch}
              setSelectedValue={setBookNameSearch}
              selectedId={bookNameIds}
              setSelectedId={setBookNameIds}
              placeholder="Select Book "
            />

          </Col>

          {/* ==Month wise== */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Month"
              data={monthList}
              selectedValue={monthSearch}
              setSelectedValue={setMonthSearch}
              selectedId={monthIds}
              setSelectedId={setMonthIds}
              placeholder="Select Month "
            />
          </Col>

          {/* Item Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <MaintennanceDropDownFilter
              label="Machine Group"
              data={machineGroupList}
              selectedValue={machineGroupSearch}
              setSelectedValue={setMachineGroupSearch}
              selectedId={machineGroupIds}
              setSelectedId={setMachineGroupIds}
              placeholder="Select MachineGroup "
            />
          </Col>

          {/* Button */}
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mt-3 hover-scale-btn "
          >
            <button
              onClick={handleSubmit1}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour11,
                color: "#fff",
                fontWeight: "700",
                border: "none",
              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>

      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour11,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          ITEMWISE DAILY V/S MONTHLY TABLE
        </div>

        <MaintananceTable columns={columns} data={initialData} />
      </div>

      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <MaintenanceCelender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour11,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemWiseDailyAndMonthly;
